// extracted by mini-css-extract-plugin
module.exports = {"strike":"Strike__strike___1XV1b","strikeContent":"Strike__strikeContent___10gLb"};